import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
	selector: "app-factory-reset-confirm",
	templateUrl: "./factory-reset-confirm.component.html",
	styleUrls: ["./factory-reset-confirm.component.scss"],
})
export class FactoryResetConfirmComponent {
	constructor(private modalController: ModalController) {}

	dismiss = (confirmed: boolean) => this.modalController.dismiss(confirmed);
}
